// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Lcd4X","loader":"styles_loader__CR5gK"};